import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import log from 'pathfinder/utils/log';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { fetchArticleStatsData } from 'pathfinder/modules/ArticleContributionStats/api/articleStats';
import { renderStats } from 'pathfinder/modules/ArticleContributionStats/renderStats';
import { trackImpression } from 'pathfinder/modules/ArticleContributionStats/utils/tracking';
const OPTIMIZELY_VARIABLES = {
    EXPERIMENT_ENABLED: 'optimizely_enable_social_proof_article_contribution_stats',
    EXPERIMENT_VARIANT: 'optimizely_enable_social_proof_article_contribution_stats_variant_name',
};
const VARIANTS = {
    WITH_EDITOR_STATS: `UGC-4377-with-editors-stats`,
    CONTROL: `UGC-4377-control`,
};
export const getArticleContributionStatsModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const moduleProps = buildModuleProps(moduleConfig, {});
        const { track } = moduleProps;
        const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
        const variant = yield getOptimizelyVariant(isForced, OPTIMIZELY_VARIABLES, VARIANTS);
        if (!variant) {
            return null;
        }
        const mainContainer = document.querySelector('#toc');
        if (!mainContainer) {
            return null;
        }
        const articleId = window.mw.config.get('wgArticleId');
        if (!articleId) {
            return null;
        }
        const data = yield fetchArticleStatsData(articleId);
        if (!data || (data === null || data === void 0 ? void 0 : data.article_contributions) <= 1) {
            return null;
        }
        const render = () => {
            if (variant === VARIANTS.WITH_EDITOR_STATS) {
                renderStats(mainContainer, data, track, variant) && trackImpression(track, variant);
            }
            if (variant === VARIANTS.CONTROL) {
                trackImpression(track, variant);
            }
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('ArticleContributionStatsModule error', error);
    }
    return null;
});
